import { action, Action } from 'easy-peasy';

interface IFreeNum {
    // 剩余试用次数
    leftFreeNum: number;
    // 试用次数额度
    freeNum: number;
}
export interface ICutoutVipModel {
    freeCount: IFreeNum;
    setFreeCount: Action<ICutoutVipModel, IFreeNum>;
}

export const cutoutVipModel: ICutoutVipModel = {
    freeCount: {
        leftFreeNum: 0,
        freeNum: 0,
    },
    setFreeCount: action((state, freeNum) => {
        state.freeCount = freeNum;
    }),
};
